// eslint-disable-next-line no-restricted-imports
import {devtools as zustandDevtools} from 'zustand/middleware';

import {IS_DEV_ENV} from 'config';

export const devtools: typeof zustandDevtools = (store, options) => {
  return zustandDevtools(store, {...options, enabled: IS_DEV_ENV && !!window.__REDUX_DEVTOOLS_EXTENSION__});
};
